import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path1/apps/web/src/app/(front)/auth/register/PasswordSignUpForm.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/vercel/path1/node_modules/.pnpm/next@15.1.7_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path1/packages/i18n/src/Trans.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path1/packages/ui/src/components/Image.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path1/packages/ui/src/providers/OauthProviders.tsx");
